export default __webpack_public_path__ + "images/7a73c79d430a65289cf5f5fed9b09b7a-career.webp";